import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import VerticalMenu from "../components/VerticalMenu";

const HomeLayout = () => {

  const isLoggedIn = localStorage.getItem("user"); // or however you store it

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <div style={{ width: "auto", paddingLeft: '10vh', paddingRight: '10vh',borderRight: "1px solid #ddd" }}>
        <VerticalMenu />
      </div>
      <div style={{ flex: 1, padding: "2rem", overflowY: "auto" }}>
        <Outlet />
      </div>
    </div>
  );
};

export default HomeLayout;
